import { useDispatch, useSelector } from 'react-redux';

import { Alert, Grid, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { hideNotificationMessage } from '@store/dashboard';
import { HEADER_HEIGHT } from '@dashboardComponents/ApplicationTemplate/ApplicationTemplate';

import LoggedInPageHeader from '../LoggedInPageHeader/LoggedInPageHeader';
import styles from './LoggedInPageTemplate.module.css';

function LoggedInPageTemplate({ children }) {
  const dispatch = useDispatch();
  const notificationMessage = useSelector(
    (state) => state.dashboard.notificationMessage,
  );

  const handleSnackBarClose = () => {
    dispatch(hideNotificationMessage());
  };

  return (
    <>
      <Grid
        container
        className={styles.LoggedInPageTemplate}>
        <Grid
          item
          xs={12}
          style={{ width: '100%' }}>
          <LoggedInPageHeader />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            width: '100%',
            height: `calc(100vh - ${HEADER_HEIGHT}px)`,
            minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`,
            backgroundColor: 'white',
          }}>
          {children}
        </Grid>
      </Grid>
      <Snackbar
        open={notificationMessage.show}
        autoHideDuration={
          notificationMessage.duration ? notificationMessage.duration : 1000
        }
        onClose={handleSnackBarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleSnackBarClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }>
        <Alert
          onClose={handleSnackBarClose}
          severity={
            notificationMessage.severity
              ? notificationMessage.severity
              : 'success'
          }
          sx={{ width: '100%' }}>
          {notificationMessage.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default LoggedInPageTemplate;
